import React, { useEffect, useState } from "react";
// import Modal from "react-modal";
import axios from "axios";
import { Link } from "react-router-dom";
import { baseUrl } from "../../../enum/constant";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "./PopUpModal.css";

const SignupModal = ({ isOpen, onRequestClose, onLoginClick }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showPassword1, setShowPassword1] = useState(false);
  const [checked, setChecked] = useState(false);

  const toggleShow = () => {
    setShowPassword((prev) => !prev);
  };

  const toggleShow1 = () => {
    setShowPassword1((prev) => !prev);
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    // Check if passwords match
    if (password !== confirmPassword) {
      setError("Passwords do not match.");
      setTimeout(() => {
        setError("");
      }, 3000);
      return;
    }

    setLoading(true);

    try {
      const base = baseUrl;
      await axios.post(
        base + "api/register",
        {
          email,
          password,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      setMessage("Registration successful! Please log in.");
      setTimeout(() => {
        setMessage("");
        onRequestClose(); // Close the modal after 3 seconds
      }, 3000);

      // Clear the form fields
      setEmail("");
      setPassword("");
      setConfirmPassword(""); // Clear the confirm password field
    } catch (error) {
      const response = error.response;

      if (response && response.status === 400) {
        const errors = response.data;
        if (errors.email) {
          setError(errors.email[0]); // Display the specific email error
        } else {
          setError("Password should be at least 8 characters");
        }
      } else {
        setError("An unexpected error occurred. Please try again later.");
      }
      setTimeout(() => setError(""), 3000); // Hide the error message after 3 seconds
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setEmail("");
    setPassword("");
    setConfirmPassword("");
    setShowPassword(false);
    setShowPassword1(false);

    return () => {
      setEmail("");
      setPassword("");
      setConfirmPassword("");
      setShowPassword(false);
      setShowPassword1(false);
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <>
      <div className="pop-main" onClick={onRequestClose}>
        <div className="pop-wrap" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <form onSubmit={handleSignup}>
              <button
                type="button"
                onClick={onRequestClose}
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">
                  Sign up now
                </h5>
              </div>
              {error && (
                <div className="alert alert-danger text-center mt-3">
                  {error}
                </div>
              )}
              {message && (
                <div className="alert alert-success text-center mt-3">
                  {message}
                </div>
              )}
              <div className="modal-body">
                <div className="fm-outer">
                  <label>Email</label>
                  <input
                    className="fm-cont"
                    type="text"
                    placeholder="Enter your email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  {/* <div className="error">
                      <span>Validation will sow here developr will update this and hide this.</span>
                    </div> */}
                </div>
                <div className="fm-outer pass-view cus-pass-div">
                  <label>Password</label>
                  <input
                    className="fm-cont"
                    type={showPassword ? "text" : "password"}
                    placeholder="Enter your Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  {showPassword ? (
                    <div className="eye-div" onClick={toggleShow}>
                      <img
                        className="eye-slash"
                        src="images/new/eye-slash.png"
                      />
                    </div>
                  ) : (
                    <div className="eye-div" onClick={toggleShow}>
                      <img className="eye" src="images/new/eye.png" />
                    </div>
                  )}
                </div>
                <div className="fm-outer pass-view cus-pass-div">
                  <label>Confirm Password</label>
                  <input
                    className="fm-cont"
                    type={showPassword1 ? "text" : "password"}
                    placeholder="Enter your Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                  {showPassword1 ? (
                    <div className="eye-div" onClick={toggleShow1}>
                      <img
                        className="eye-slash"
                        src="images/new/eye-slash.png"
                      />
                    </div>
                  ) : (
                    <div className="eye-div" onClick={toggleShow1}>
                      <img className="eye" src="images/new/eye.png" />
                    </div>
                  )}
                </div>
                {/* <div className="fom-row">
                  <div className="custom-control custom-checkbox">
                    <input type="checkbox" className="custom-control-input" id="customCheck1" />
                    <label className="custom-control-label" for="customCheck1">I’ve read and agree to the Kittrow. <a href='#'>Terms of use</a></label>
                  </div>
                </div> */}
                <div className="mb-3">
                  <div className="form-check">
                    <input
                      required
                      type="checkbox"
                      className="form-check-input"
                      id="exampleCheck1"
                      value={checked}
                      onChange={() => setChecked(!checked)}
                    />
                    <label className="form-check-label" htmlFor="exampleCheck1">
                      I've read and agree to the Kittrow Investments s.r.o.{" "}
                      <Link target="_blank" to="/terms-of-use">
                        Terms of Use
                      </Link>
                      {/* <Link target="_blank" to="/privacy">Privacy Policy</Link> */}
                    </label>
                  </div>
                </div>
                <div className="button-group">
                  <button
                    type="submit"
                    disabled={!checked || loading}
                    className={`btn ${checked ? "blue-btn" : "grey-btn"} `}
                  >
                    {loading ? "Signing up..." : "Sign up"}
                  </button>
                </div>
                <div className="mt-3 new-t text-center">
                  <p>
                    Already registered?{" "}
                    <a href="#" className="forgot" onClick={onLoginClick}>
                      Sign In
                    </a>
                  </p>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default SignupModal;
